<!-- 自评管理页 -->
<template>
  <div id="edit_reviewManagement" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">自评管理</div>
    <!-- 编辑表单 -->
    <div class="edit_form">
      <el-row class="card_red">
        <!-- 评审类型设置 -->
        <el-row class="model">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">评审类型设置</el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-radio-group v-model="selfEvaItem.type" :disabled="$route.query.id != undefined">
              <el-radio :label="2">年度评审</el-radio>
              <el-radio :label="1">日常评审</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-row>
      <!-- 年度评审 -->
      <el-row v-if="selfEvaItem.type == 2" class="card_red">
        <el-row class="model">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">默认所有企业参与</el-col>
        </el-row>
      </el-row>
      <el-row v-if="selfEvaItem.type == 2" class="card_red">
        <el-row class="model">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">使用默认评价依据</el-col>
        </el-row>
      </el-row>
      <el-row v-if="selfEvaItem.type == 2" class="card_blue">
        <el-row class="model">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">自评时间设置</el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="flexStart">
              <el-radio-group v-model="selfEvaItem.timeType">
                <el-radio :label="1">全时段可自评</el-radio>
                <el-radio :label="2">规定时段可自评</el-radio>
              </el-radio-group>
              <el-date-picker
                v-model="selfEvaItem.times"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                :disabled="selfEvaItem.timeType == 1"
                :picker-options="pickerOptions"
                style="margin-left: 10px">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
      </el-row>
      <!-- 日常评审 -->
      <el-row v-if="selfEvaItem.type == 1" class="card_red">
        <!-- 选择参与评审企业 -->
        <el-row class="model">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">选择参与评审企业</el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-row>
              <el-table
                class="fitPc"
                :data="enterprieList_table"
                :cell-style="cellStyle"
                :header-cell-style="headerCellStyle"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                row-key="userId">
                <el-table-column :reserve-selection="true" type="selection" width="45"></el-table-column>
                <el-table-column
                  v-for="(item, i) in tableKeys_current"
                  :key="i"
                  :prop="item.key"
                  :label="item.title"
                  :sortable="item.sortable ? 'custom' : false"
                  show-overflow-tooltip
                  :min-width="item.width ? item.width : ''"
                  :align="item.align ?? 'center'">
                  <template slot-scope="props">
                    <div v-if="item.type == 'status'" :class="item.class_status ? item.class_status[props.row[item.key]] : ''">
                      {{ item.text_status[props.row[item.key]] ? item.text_status[props.row[item.key]] : '--' }}
                    </div>
                    <div v-else-if="item.type == 'money'" class="nowrap">{{ `￥${common.formatNumber(props.row[item.key])}` }}</div>
                    <div v-else-if="item.type == 'time'" class="nowrap">{{ props.row[item.key] ? moment(props.row[item.key]).format('YYYY-MM-DD HH:mm:ss') : '--' }}</div>
                    <div v-else class="nowrap">{{ props.row[item.key] ? props.row[item.key] : '--' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" prop="" show-overflow-tooltip align="center">
                  <template #default="scope">
                    <el-button
                      v-if="!scope.row.status || scope.row.status == 1"
                      type="text"
                      @click="(ifSimple_Setting = true), (dialog_enterpries = [scope.row]), (visible_dialog = true)"
                      >评审设置</el-button
                    >
                    <el-button
                      v-else-if="scope.row.status > 1"
                      type="text"
                      @click="
                        $router.push({
                          path: '/detail_simple',
                          query: { id: reviewItem.id, userId: props.row.id },
                        })
                      "
                      >查看详情</el-button
                    >
                  </template>
                </el-table-column>
                <div slot="empty">
                  <img src="../../assets/img/emptyData.png" alt="" />
                </div>
              </el-table>
              <!-- 移动端 -->
              <div class="listIpone">
                <template v-if="enterprieList_table && enterprieList_table.length">
                  <el-checkbox class="contCheak" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                  <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                    <el-checkbox class="listIBox" v-for="(item, index) in enterprieList_table" :key="`${index}c`" :label="item">
                      <div class="listIponeItem">
                        <div class="left">
                          <div class="tiles">
                            {{ item.enterprieName }}
                          </div>
                          <div class="time" v-if="item.category">
                            目前所涉及的行业:<span>{{ item.category || '--' }}</span>
                          </div>
                          <div class="time">
                            截止时间:<span v-if="item.endTime"> {{ moment(item.endTime).format('YYYY.MM.DD HH:mm:ss') }}</span>
                            <span v-else>暂无</span>
                          </div>
                          <div class="time" v-if="item.paperName">
                            评审依据:<span>{{ item.paperName || '--' }}</span>
                          </div>
                        </div>
                        <div class="right">
                          <el-button v-if="!item.status || item.status == 1" type="text" @click="(ifSimple_Setting = true), (dialog_enterpries = [item]), (visible_dialog = true)">
                            评审设置
                          </el-button>
                          <el-button
                            v-else-if="item.status > 1"
                            type="text"
                            @click="
                              $router.push({
                                path: '/detail_simple',
                                query: { id: reviewItem.id, userId: props.row.id },
                              })
                            ">
                            查看详情
                          </el-button>
                        </div>
                      </div>
                    </el-checkbox>
                  </el-checkbox-group>
                  <!--    -->
                </template>
                <div v-else style="text-align: center">
                  <img src="../../assets/img/emptyData.png" alt="" />
                </div>
              </div>
            </el-row>
            <!-- 分页 -->
            <div class="pagination">
              <div>共{{ total_table }}条数据</div>
              <el-pagination
                hide-on-single-page
                background
                @current-change="handleCurrentChange"
                :current-page.sync="queryParam.page"
                :page-size="queryParam.limit"
                :pager-count="5"
                :layout="'prev, pager, next'"
                :total="total_table">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-row>
    </div>
    <!-- 表单按钮 -->
    <div class="absoluteGrop">
      <el-button type="primary" @click="submitEdit()">{{ $route.query.id ? '保 存' : '开始评审流程' }}</el-button>
      <el-button v-if="selfEvaItem.type == 1" type="primary" plain @click="settingAll()">批量评审配置</el-button>
      <el-button
        v-if="$route.query.id"
        type="primary"
        plain
        @click="
          $router.push({
            path: '/detail_reviewManagement',
            query: { id: selfEvaItem.id },
          })
        "
        >查看本次评审情况</el-button
      >
      <el-button plain @click="$router.go(-1)">返 回</el-button>
    </div>
    <!-- 弹窗-评审设置 -->
    <el-dialog
      class="enterpriseEvaDialog"
      top="25vh"
      :visible.sync="visible_dialog"
      title="评审设置"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
      width="370px">
      <el-row style="margin-bottom: 10px">
        <div class="theme">已选择企业</div>
        <div>
          <span v-for="(enterprie, e) in dialog_enterpries" :key="e">{{ enterprie.enterprieName || enterprie.userName }};</span>
        </div>
      </el-row>
      <el-form :model="enterpriseEva" :rules="rules_enterpriseEva" ref="enterpriseEva" label-width="100px" label-position="top">
        <el-form-item label="选择评审细则" prop="paperId">
          <el-select v-model="enterpriseEva.paperId" placeholder="请选择评审细则" style="width: 100%">
            <el-option v-for="(paper, p) in paperList" :key="p" :label="paper.name" :value="paper.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择自评截止时间" prop="endTime">
          <el-date-picker v-model="enterpriseEva.endTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"> </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEdit('enterpriseEva')">确 认</el-button>
        <el-button @click="visible_dialog = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'edit_reviewManagement',
  data() {
    return {
      checkAll: false,
      checkedCities: [],
      isIndeterminate: false,
      moment: moment,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      selfEvaItem: { type: 2, times: [], timeType: 1 },
      paperList: [],
      //企业列表
      tableKeys_current: [
        { title: '企业名称', key: 'enterprieName' },
        { title: '目前所涉及的行业', key: 'category' },
        { title: '评价依据', key: 'paperName' },
        { title: '自评截止时间', key: 'endTime', type: 'time' },
      ],
      enterprieList_table: [],
      total_table: 0,
      queryParam: {
        keyWords: '',
        page: 1,
        limit: 10,
      },
      selected_enterprie: [],
      dialog_enterpries: [],
      // 弹窗-评审配置
      visible_dialog: false,
      ifSimple_Setting: false, //是否单个企业设置（列表单行设置）
      enterpriseEva: { paperId: '' },
      rules_enterpriseEva: {
        paperId: [{ required: true, message: '请选择评审细则', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择自评截止时间', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.getPaperList();
  },
  mounted() {
    if (this.$route.query.id) {
      this.getUserList_table().then((res) => {
        this.getInfo();
      });
    } else {
      this.getUserList_table();
    }
  },
  methods: {
    //获取自评信息
    getInfo() {
      this.$axios
        .post(`${process.env.BASE_URL}api/reviewRecord/recordInfo`, { id: this.$route.query.id })
        .then((res) => {
          if (res.data.code == 200) {
            this.selfEvaItem = JSON.parse(JSON.stringify(res.data.data));
            if (this.selfEvaItem.type == 2) {
              if (this.selfEvaItem.timeType == 2 && this.selfEvaItem.userList.length) {
                this.selfEvaItem.times = [this.selfEvaItem.startTime, this.selfEvaItem.endTime];
              }
            }
            if (this.selfEvaItem.userList && this.selfEvaItem.userList.length) {
              this.selected_enterprie = JSON.parse(JSON.stringify(this.selfEvaItem.userList));
              let that = this;
              that.$nextTick(() => {
                that.enterprieList_table.forEach((user) => {
                  that.selected_enterprie.forEach((row) => {
                    if (user.userId == row.userId) {
                      that.$set(user, 'paperName', row.paperName);
                      that.$set(user, 'recoreId', row.id);
                      that.$set(user, 'endTime', row.endTime);
                      that.$set(user, 'paperId', row.paperId);
                    }
                    that.$refs.multipleTable.toggleRowSelection(row, true);
                  });
                });
              });
            }
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取评审细则List
    getPaperList() {
      this.$axios
        .post(`${process.env.BASE_URL}api/examination/examinationList`, { keyWords: '', limit: 999999, page: 1 })
        .then((res) => {
          if (res.data.code == 200) {
            this.paperList = JSON.parse(JSON.stringify(res.data.page.list));
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取用户列表(待用新接口)
    getUserList_table() {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(`${process.env.BASE_URL}api/reviewRecord/userList`, this.queryParam)
          .then((res) => {
            if (res.data.code === 200) {
              this.enterprieList_table = Object.assign([], res.data.page.list);
              this.total_table = res.data.page.totalCount;
              resolve(true);
            } else {
              this.$message({
                type: 'error',
                message: '查询失败-' + res.data.msg,
                offset: 80,
              });
              resolve(false);
            }
          })
          .catch((err) => {
            console.log(err);
            resolve(false);
          });
      });
    },
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.getUserList_table();
    },
    handleSelectionChange(val) {
      console.log(`🚀 ~ val:`, val);
      this.selected_enterprie = val;
    },
    // 批量设置
    settingAll() {
      if (!this.selected_enterprie.length) {
        this.$message.warning('请选择企业进行批量配置');
      } else {
        this.ifSimple_Setting = false;
        this.dialog_enterpries = this.selected_enterprie;
        this.visible_dialog = true;
      }
    },
    // 提交-设置评审
    submitEdit(formName) {
      if (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let paperName = '';
            let selected_paper = this.paperList.filter((item) => {
              return this.enterpriseEva.paperId == item.id;
            });
            selected_paper.forEach((sel) => {
              paperName += sel.name + '；';
            });
            if (this.ifSimple_Setting) {
              //单行设置
              let preEle = this.selected_enterprie.filter((user) => {
                return user.userId == this.dialog_enterpries[0].id;
              });
              this.$set(this.dialog_enterpries[0], 'paperName', paperName);
              this.$set(this.dialog_enterpries[0], 'endTime', this.enterpriseEva.endTime);
              this.$set(this.dialog_enterpries[0], 'paperId', this.enterpriseEva.paperId);
              if (!preEle.length) {
                //新增选择
                this.selected_enterprie.push(this.dialog_enterpries[0]);
                this.$refs.multipleTable.toggleRowSelection(this.dialog_enterpries[0], true);
              } else {
                //替换编辑
                this.selected_enterprie.forEach((user) => {
                  if (user.userId == this.dialog_enterpries[0].id) {
                    this.$set(user, 'paperName', paperName);
                    this.$set(user, 'endTime', this.enterpriseEva.endTime);
                    this.$set(user, 'paperId', this.enterpriseEva.paperId);
                  }
                });
              }
            } else {
              //批量设置
              this.dialog_enterpries.forEach((enterpries) => {
                this.$set(enterpries, 'paperName', paperName);
                this.$set(enterpries, 'endTime', this.enterpriseEva.endTime);
                this.$set(enterpries, 'paperId', this.enterpriseEva.paperId);
              });
            }
            this.visible_dialog = false;
          } else {
          }
        });
      } else {
        if (this.selfEvaItem.type == 1 && !this.selected_enterprie.length) {
          this.$message.warning('请选择企业进行配置');
        } else {
          let ifSubmit = true;
          if (this.selfEvaItem.type == 1) {
            //日常评审-字段排查
            this.selected_enterprie.forEach((selected) => {
              this.$set(selected, 'id', selected.userId);
              if (!selected.paperName || !selected.endTime) {
                ifSubmit = false;
                this.$message.warning('请配置评审评审细则及自评截止时间');
                return false;
              }
            });
          } else {
            if (this.selfEvaItem.timeType == 2 && (!this.selfEvaItem.times || !this.selfEvaItem.times.length)) {
              ifSubmit = false;
              this.$message.warning('请配置可自评时段');
            }
          }
          if (ifSubmit) {
            let param = { type: this.selfEvaItem.type };
            if (this.$route.query.id) {
              this.$set(param, 'id', this.$route.query.id);
            }
            if (this.selfEvaItem.type == 2) {
              //年度评审-字段拼接
              this.$set(param, 'timeType', this.selfEvaItem.timeType);
              if (this.selfEvaItem.timeType == 2) {
                this.$set(param, 'startTime', this.selfEvaItem.times[0]);
                this.$set(param, 'endTime', this.selfEvaItem.times[1]);
              }
            } else {
              //日常评审-字段拼接
              let users = [];
              this.selected_enterprie.forEach((user) => {
                let item = {
                  endTime: user.endTime,
                  id: user.userId,
                  paperId: user.paperId,
                };
                if (user.recoreId) {
                  this.$set(item, 'recoreId', user.recoreId);
                }
                users.push(item);
              });
              this.$set(param, 'users', users);
            }
            this.$axios
              .post(`${process.env.BASE_URL}api/reviewRecord/addRecord`, param)
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message.success('操作成功');
                  this.$router.push({
                    path: '/reviewManagement',
                  });
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      }
    },
    // 列表-表头样式
    headerCellStyle(header) {
      if (header.column.order == 'ascending' || header.column.order == 'descending') {
        return { color: '#3D7BDC', fontSize: '14px', fontWeight: 400, background: '#f9fafb' };
      } else {
        return { color: '#617180', fontSize: '14px', fontWeight: 400, background: '#f9fafb' };
      }
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.enterprieList_table : [];
      this.isIndeterminate = false;
      this.handleSelectionChange(this.checkedCities);
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.enterprieList_table.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.enterprieList_table.length;
      this.handleSelectionChange(this.checkedCities);
    },
    // 列表-单元格样式
    cellStyle() {
      return {
        fontSize: '14px',
        color: '#111928',
        fontWeight: 500,
        padding: '8px 0px',
        background: '#f9fafb',
      };
    },
  },
};
</script>
<style lang="less" scoped>
#edit_reviewManagement {
  /deep/.el-radio-group {
    display: grid;
    align-items: center;
    align-content: stretch;
    justify-content: start;
    > label {
      margin-bottom: 5px;
      margin-right: 0px;
    }
  }
}
// pc端
.edit_form {
  // margin-bottom: 80px;

  /deep/.el-input,
  /deep/.el-textarea {
    max-width: 500px;
  }

  /deep/.el-select,
  /deep/.el-date-editor {
    width: 300px;
  }
}
.card_red,
.card_blue {
  position: relative;
  padding: 10px 18px;
  border-radius: 5px;
  background-color: rgba(80, 88, 105, 0.06);
  margin-bottom: 10px;
  &::after {
    position: absolute;
    left: 0px;
    top: 8px;
    content: '';
    width: 3px;
    height: 23px;
  }
  .model {
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid rgba(80, 88, 105, 0.24);
    /deep/.el-tree {
      background-color: #f5f5f6;
      margin-bottom: 20px;
    }
    > .el-col:first-child {
      margin-bottom: 10px;
    }
  }
}
.card_red::after {
  background: #df5151;
}
.card_blue::after {
  background: #0170f2;
}
.enterpriseEvaDialog {
  /deep/.el-dialog__body {
    padding: 10px 20px;
  }
}
.listIpone {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  .listIBox {
    margin-bottom: 15px;
    padding: 10px 10px;
    border: 1px solid #dde1e6;
    margin-right: 0 !important;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    /deep/.el-checkbox__label{
      width: 100%;
    }
  }
  .contCheak {
    margin: 10px 0;
  }
  .listIponeItem {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    position: relative;
    // cursor: pointer;
    .isChied {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      background-color: #f68e6d;
      border-radius: 6px;
      padding: 3px 6px;
      color: #fbfdff;
    }
    .left {
      .tiles {
        color: #4f5d77;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        .tiltBox {
          width: 6px;
          height: 6px;
          margin-right: 8px;
          display: inline-block;
        }
        .tileOrruge {
          background: #f68e6d;
        }
        .tileRed {
          background: #df5151;
        }
        .tileBlue {
          background: #499bde;
        }
        .tileGreen {
          background: #5b9f7b;
        }
      }
      .time {
        color: rgba(79, 93, 119, 0.6);
        line-height: 25px;
        span {
          color: #4f5d77;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.01px;
        }
      }
      .box {
        width: 76px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        border-radius: 18px;
        font-size: 12px;
        margin-top: 4px;
      }
      .DayBox {
        border-radius: 18px;
        background: rgba(79, 93, 119, 0.16);
        color: rgba(79, 93, 119, 0.7);
      }
      .YearBox {
        border-radius: 18px;
        background: rgba(62, 123, 250, 0.16);
        color: rgba(62, 123, 250, 0.7);
      }
    }
    .right {
      margin-left: auto;
    }
  }
  .rowList {
    color: rgba(79, 93, 119, 0.6);
    font-size: 14px;
    line-height: 25px;
  }
}
/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .edit_form {
    /deep/.el-select,
    /deep/.el-date-editor {
      width: 70%;
    }
  }

  .flexStart {
    /deep/.el-select {
      width: 70%;
    }
  }
  .card_red,
  .card_blue {
    &::after {
      left: 10px;
    }
  }
  .fitPc {
    display: none;
  }
  .listIpone {
    display: flex;
  }
}
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
  #edit_reviewManagement {
    .fitPc {
      display: block;
    }
    .listIpone {
      display: none;
    }
  }
}
</style>
